import type { I18n } from '@lingui/core'

import {
  TENANT_AT,
  TENANT_BE,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts'
import { type Tenant } from 'types/shopConfig'

export const getPlaceholderText = ({
  i18n,
  tenant,
  defaultPlaceholderText,
}: {
  i18n: I18n
  tenant: string
  defaultPlaceholderText: string
}) => {
  if ([TENANT_AT, TENANT_COM, TENANT_FR, TENANT_IT].includes(tenant)) {
    return i18n._('general.label.placeholder.searchYourProduct')
  } else {
    return defaultPlaceholderText
  }
}

type SuggestionParametersReturnType = {
  showRatings: boolean
  showReducedPrice: boolean
  showDiscountBubble: boolean
}

export const getSuggestionParameters = (
  tenant: Tenant
): SuggestionParametersReturnType => {
  if ([TENANT_COM, TENANT_CH, TENANT_IT].includes(tenant)) {
    return {
      showRatings: false,
      showReducedPrice: true,
      showDiscountBubble: false,
    }
  } else if ([TENANT_AT, TENANT_BE, TENANT_FR].includes(tenant)) {
    return {
      showRatings: false,
      showReducedPrice: true,
      showDiscountBubble: true,
    }
  } else {
    return {
      showRatings: false,
      showReducedPrice: false,
      showDiscountBubble: false,
    }
  }
}

export const getLegalSupNumberForTenant = (tenant: Tenant) => {
  switch (tenant) {
    case TENANT_AT:
      return '2'
    case TENANT_COM:
      return '1'
    default:
      return ''
  }
}
